module.exports = "/img/_/_/_/assets/images/avatar/full_right/male//drow.jpg?f70709d5682829f6121267dae43eba5d";